import Notifications from "./Notifications";

const NotificationsRouter = [
  {
    type: "private",
    path: "/notificaciones",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "responsable",
      "alta_direccipn",
      "Responsable_OnBoarding",
      "Respondable_OffBoarding",
      "Respondable_Sanciones",
      "Encargado_Sanciones",
      "Respondable_Descriptores_Perfiles",
      "Respondable_Seleccion_Contratacion",
      "respondable_desempeno_laboral",
      "Respondable_Evaluacion",
    ],
    component: Notifications,
    exact: true,
  },
  {
    type: "private",
    path: "/notificaciones/:idNotificaciones",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "responsable",
      "alta_direccipn",
      "Responsable_OnBoarding",
      "Respondable_OffBoarding",
      "Respondable_Sanciones",
      "Encargado_Sanciones",
      "Respondable_Descriptores_Perfiles",
      "Respondable_Seleccion_Contratacion",
      "respondable_desempeno_laboral",
      "Respondable_Evaluacion",
    ],
    component: Notifications,
    exact: true,
  },
];

export default NotificationsRouter;
